var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttFirstInteraction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 84,
    height: 27,
    viewBox: "0 0 84 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-382 -579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 27,
    rx: 13.5,
    transform: "translate(382 579)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.623,1307.427a3.822,3.822,0,0,0-3.571,2.444h-8.524a3.847,3.847,0,0,0-7.189,0h-8.524a3.842,3.842,0,0,0-7.157,0h-4.311a7.914,7.914,0,1,0,0,2.8h4.311a3.832,3.832,0,0,0,7.157,0h8.54a3.85,3.85,0,0,0,7.157,0h8.54a3.84,3.84,0,1,0,3.571-5.242Zm-42.138,5.242a5.163,5.163,0,1,1,0-2.8,4.9,4.9,0,0,1,.193,1.383A5.117,5.117,0,0,1,229.485,1312.669Z",
    transform: "translate(178.382 -718.309)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttFirstInteraction);
export default __webpack_public_path__ + "static/media/att-first-interaction.bb77b2119e6e5cae6fb295ddc518443a.svg";
export { ForwardRef as ReactComponent };